<h4 mat-dialog-title>
  {{ data.titleKey ? (data.titleKey | translate) : data.titleText }}
</h4>
<div mat-dialog-content>
  {{ data.message || data.messageKey | translate }}
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ data.okKey ? (data.okKey | translate) : data.okText }}
  </button>
</div>
